let ROUTE_BASE_URL = './';
let API_BASE_URL = './';
let MOBILE_CONFIG = require('./mobile-config-prod');
if (process.env.NODE_ENV === 'development') {
	MOBILE_CONFIG = require('./mobile-config-dev');
	ROUTE_BASE_URL = '/order-activation-backend';
	API_BASE_URL = '/order-activation-backend';
}

export { ROUTE_BASE_URL, API_BASE_URL, MOBILE_CONFIG };
